import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconDefaultAvatarLightColor from './icon-default-avatar-light-color.vue';

const IconDefaultAvatarLightColor = Object.assign(_IconDefaultAvatarLightColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconDefaultAvatarLightColor.name, _IconDefaultAvatarLightColor);
  }
});

export default IconDefaultAvatarLightColor;
